import { LayoutComponent } from '@geogirafe/lib-geoportal/components';

export default class MapBSLayoutComponent extends LayoutComponent {
  override templateUrl = './template.html';
  override styleUrls = [
    '../../../node_modules/@geogirafe/lib-geoportal/styles/common.css',
    '../../../node_modules/@geogirafe/lib-geoportal/components/layout/style.css'
  ];

  public constructor() {
    super();
    this.openLink = this.openLink.bind(this);
  }

  public openLink() {
    //define variables
    const baseUrl = 'https://3d.geo.bs.ch/?x={x}&y={y}&elevation={elevation}&pitch=-{angel}';
    const degrees = 60;
    const scale = this.state.position?.scale ?? 10000; //if undefined use 10'000 as default
    const elevation = scale / Math.tan((degrees * Math.PI) / 180);

    const layer = this.state.activeBasemaps[0]?.name; //get the layer name
    let layerAddition = ''; //default with colour basemap no layer parameter needed
    if (layer === 'Grundkarte grau' || layer === 'Stadtplan_grau') {
      //create layer parameter for grey
      layerAddition = '&layers=+3D-Stadtmodell/Grundkarte/Stadt- und Parzellenplan (grau)';
    } else if (layer === 'Empty') {
      //create layer parameter for no backgound map
      layerAddition = '&layers=-3D-Stadtmodell/Grundkarte';
    }

    //modify the base url
    let url = baseUrl.replace('{x}', this.state.position?.center[0].toFixed(2));
    url = url.replace('{y}', this.state.position?.center[1].toFixed(2));
    url = url.replace('{elevation}', elevation.toFixed(0));
    url = url.replace('{angel}', degrees.toLocaleString());
    url = url.concat(layerAddition);

    window.open(url, '_blank'); //url call
  }
}
